
// This file exports functions from other service files to maintain backward compatibility
import { getHealthPoints as getPoints } from './points/pointsService';

export const getHealthPoints = getPoints;
